import { z } from "zod";

import { CustomerCategory } from "./model";

export const customerCategorySchemaFactory = (customerCategories: CustomerCategory[], existingId?: string) => {
    const filteredCategories = (existingId
        ? customerCategories?.filter(cc => cc.id !== existingId)
        : customerCategories) ?? [];
    const schema = z.object({
        name: z.string({ required_error: "Name is required" })
            .min(1)
            .refine(
                (name: string) => !filteredCategories.some(cc => cc.name.toUpperCase() === name.toUpperCase()),
                (value) => ({ message: `Customer category '${value}' already exists.` })),
        id: z.string().optional()
    });

    return schema;
};
